import secondaryComponents from "../../../../components/secondaryComponents";
import primaryComponents from "../../../../components/primaryComponents";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";

const CreateJournalEntry = () => {
  const navigate = useNavigate();

  return (
    <>
      <secondaryComponents.LoaderHelper classNames="mt-5">
        <div className="d-flex align-items-center" style={{ gap: "10px" }}>
          <primaryComponents.Button
            classNames="btn btn--outline"
            onClick={() => navigate(-1)}
          >
            <FontAwesomeIcon
              icon="angle-left"
              className="mr-3"
              style={{ fontSize: "18px" }}
            />
            <span>Back</span>
          </primaryComponents.Button>

          <h4 className="font-weight-semibold mb-0">New Manual Journal</h4>
        </div>
        <secondaryComponents.JournalEntryForm />
      </secondaryComponents.LoaderHelper>
    </>
  );
};

export default CreateJournalEntry;
